import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { ReleaseMode } from 'shell/models/release-mode';
import { ReleaseModeResponse, ReleaseModeClient } from 'front-office/view-models/release-mode';
import { DateTime } from 'luxon';
import { useModes } from '../shared/use-mode-list';

export const transformReleaseModeList = (
  response: AxiosResponse<HttpResponseList<ReleaseMode>>
): ReleaseModeResponse => {
  const data: Array<ReleaseMode> = response.data.payload?.list || [];

  const resList: Array<ReleaseModeClient> = data.map((mode: ReleaseMode) => {
    const use = useModes.find((item) => item.id === mode.codiceUsoModalita)?.value;

    return {
      code: mode.key?.codiceModalitaRilascio || '',
      description: mode?.descrizione,
      register: mode?.tipoRegistro || '',
      exemption: mode?.codiceEsenzioneAnpr,
      use,
      dateFrom: mode?.dataInizioValidita
        ? DateTime.fromISO(mode?.dataInizioValidita)?.toFormat('dd-MM-yyyy')
        : '',
      dateTo: mode?.dataFineValidita
        ? DateTime.fromISO(mode?.dataFineValidita)?.toFormat('dd-MM-yyyy')
        : '',
    };
  });

  return {
    count: response.data.payload?.totalRows || 0,
    list: resList || [],
  } as ReleaseModeResponse;
};
